import { render, staticRenderFns } from "./PaymentConvergeInputs.vue?vue&type=template&id=587d4020&"
import script from "./PaymentConvergeInputs.vue?vue&type=script&lang=ts&"
export * from "./PaymentConvergeInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports